import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { filter, switchMap } from 'rxjs/operators';

import { AuthorizationService, ErrorResponse } from './authorization.service';

@Injectable()
export class SocketIoService extends Socket {
  constructor(private authorizationService: AuthorizationService) {
    super(authorizationService.defaultSocketioConfiguration());

    this.fromEvent('connect_error')
      .pipe(
        filter((error: ErrorResponse) =>
          AuthorizationService.isSocketIoSessionExpired(error),
        ),
        switchMap(() => this.authorizationService.sessionExpired()),
      )
      .subscribe(() => this.disconnect());
  }

  connect(): void {
    this.setAuthorization();
    super.connect();
  }

  disconnect(): void {
    this.clearAuthorization();
    super.disconnect();
  }

  private setAuthorization(): void {
    const token = this.authorizationService.getToken();

    if (token) {
      this.ioSocket.auth = { token };
    }
  }

  private clearAuthorization(): void {
    this.ioSocket.auth = undefined;
  }
}
